import React, { useState, useEffect, useRef } from "react";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import Table from "../../../components/common/Table/Table";
import Button from "../../../components/common/Button/Button";
import { getApiInstance } from "../../../utils/api";
import { mapList } from "../../../utils/utils";
import { useZone } from "../../../context/ZoneContext";
import { ZONE_LABEL_MAP, ZONE_OPTIONS } from "../../../constants/zones";
import { useTranslation } from "react-i18next";
import { IoMdAdd } from "react-icons/io";

export default function Paises({ user }) {
    const { t } = useTranslation();
    const tableRef = useRef(null);
    const canAdd = Number(user.codAcceso) === 1 && Number(user.role) !== 4;
    const [paises, setPaises] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();

    useEffect(() => {
        fetchPaises();
    }, []);

    const fetchPaises = async () => {
        setLoading(true);
        const api = getApiInstance();

        try {
            let paisesData = [];

            const response = await api.get(
                `/api/Paises/GetPaises`
            );
            paisesData = response.data;

            console.log("Paises data fetched:", paisesData);

            //setPaises(mapList(paisesData, "pais", "codPais", "codPais"));
            setPaises(paisesData);
            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los países. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const columnasPaises = [
        {
            key: "codPais",
            label: t("countries.country"),
            sortable: true,
            visible: false,
        },
        {
            key: "pais",
            label: t("fields.country"),
            sortable: true,
            visible: true,
        },
    ];

    const filterFields = [
        { key: "pais", label: t("fields.country"), type: "multiselect" },
        { key: "codZona", label: "Zona", type: "multiselect", labelMap: ZONE_LABEL_MAP },
    ];

    if (error)
        return (
            <div className="muebles-pages__error-message">Error: {error}</div>
        );

    return (
        <PageLayout
            title={t("countries.title")}
            subtitle={t("countries.subtitle")}
            actions={[
                ...(canAdd
                    ? [
                          <Button
                              key="add"
                              variant="filled"
                              startIcon={IoMdAdd({})}
                              onClick={() => tableRef.current?.openAddModal()}
                              endIcon={undefined}
                          >
                              {`${t("common.add")} ${t("fields.country")}`}
                          </Button>,
                      ]
                    : []),
            ]}
        >
            <Table
                ref={tableRef}
                hideAddButton={true}
                columns={columnasPaises}
                dataTable={paises}
                showCheckboxes={false}
                actions={["Eliminar", "Editar"]}
                noResultsMessage={t("countries.noCountriesFound")}
                searchTerms={["pais"]}
                formElements={[
                    {
                        elements: [
                            {
                                name: "pais",
                                type: "text",
                                label: t("fields.country"),
                                placeholder: t("placeholders.enterCountry"),
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                            },
                            {
                                name: "codZona",
                                type: "select",
                                label: "Zona",
                                placeholder: "Selecciona la zona",
                                required: true,
                                disabled: false,
                                labelVisible: true,
                                visible: true,
                                options: ZONE_OPTIONS,
                            },
                        ],
                    },
                ]}
                filterFields={filterFields}
                showAdvancedFilters={false}
                loading={loading}
                elementName={t("fields.country")}
                keyProp="codPais"
                sortProp="pais"
                addApiUrl="/api/Paises/SetPais"
                editApiUrl="/api/Paises/EditPais"
                deleteApiUrl="/api/Paises/DeletePais"
                userCodAcceso={Number(user.codAcceso)}
                userCodPerfil={Number(user.role)}
            />
        </PageLayout>
    );
}
